import { render, staticRenderFns } from "./nf-header.vue?vue&type=template&id=089b0626&scoped=true"
import script from "./nf-header.vue?vue&type=script&lang=js"
export * from "./nf-header.vue?vue&type=script&lang=js"
import style0 from "./nf-header.vue?vue&type=style&index=0&id=089b0626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089b0626",
  null
  
)

export default component.exports